<template>
  <div class="container-box">
    <MediaHeader />

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="$router.push({ name: 'mediaOptionRegister' })"
        >
          <v-icon left> mdi-plus </v-icon>
          옵션 등록
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ customBoardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.name`]="{ item }">
          <router-link
            :to="{
              name: 'mediaOptionModify',
              params: { optionGroupId: item.id },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>
        <template v-slot:[`item.media_type`]="{ item }">
          {{ item.media_type.toUpperCase() }}
        </template>

        <template v-slot:[`item.items`]="{ item }">
          {{ item.items.length }}
        </template>

        <template v-slot:no-data>
          <div class="text-center">
            등록된 옵션이 없습니다. 우측상단 옵션등록 버튼을 클릭후 옵션을
            추가해주세요.
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { optionsList } from '@/api/options';
import MediaHeader from '@/views/media/header';

export default {
  components: { MediaHeader },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: 'No', value: 'no', width: '8%', sortable: false },
      { text: '옵션명', value: 'name', width: '20%', sortable: false },
      { text: '매체 타입', value: 'media_type', width: '8%', sortable: false },
      { text: 'Key', value: 'key', width: '10%', sortable: false },
      { text: '하위 옵션 수', value: 'items', width: '20%', sortable: false },
    ],
    boardLists: [],
  }),
  computed: {
    customBoardLists() {
      this.boardLists.forEach((item, index) => {
        item.no = this.boardLists.length - index;
      });
      return this.boardLists;
    },
  },
  methods: {
    async getListOption() {
      try {
        const { data } = await optionsList();
        this.boardLists = data.list.reverse();
      } finally {
        bus.$emit('end:spinner');
      }
    },
  },
  async created() {
    bus.$emit('start:spinner');

    await this.getListOption();
  },
};
</script>
